// extracted by mini-css-extract-plugin
module.exports = {"blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa"};